import { Button } from '@ethena/shared-ui/src/components/Button'
import { DAPP_URL } from '@ethena/shared-ui/src/constants/url'
import Image from 'next/image'
import Link from 'next/link'

import { SectionHeader } from '@/components/SectionHeader'

export const FinalEngagementSection = () => {
  return (
    <section className="landing-section w-full lg:!py-[40px] lg:hlg:!py-[120px]">
      <div className="landing-layout w-full mx-auto">
        <div className="rounded-b-[50px] bg-gradient-to-t from-[#BDD1F6]/60 via-[#1e222a] to-background-primary p-[1.5px] w-full">
          <div className="h-full w-full flex flex-col items-center justify-center rounded-b-[50px] bg-background-primary relative pt-[120px] pb-[110px] px-6 sm:px-8 overflow-hidden">
            <div className="absolute inset-x-0 -top-2 h-[80%] bg-[linear-gradient(360deg,rgba(9,9,11,0)_20.84%,#09090B_91.52%)] z-[2]" />
            <div className="absolute top-0 left-0 w-full h-full rounded-b-[50px] z-[1]">
              <Image
                src="/footer-ascii.png"
                alt="Footer ASCII"
                width={1920}
                height={400}
                className="object-cover object-top h-full w-full opacity-60"
                unoptimized
                priority={false}
              />
            </div>
            <div className="max-w-[480px] mx-auto z-[3]">
              <SectionHeader
                title="Join the Future of Internet Finance"
                description={
                  <>Get started with USDe, or explore Ethena&apos;s ecosystem for retail & institutional users alike.</>
                }
                titleClassName="mb-8"
                showDivider={false}
              />
              <div className="flex items-center justify-center flex-wrap gap-4">
                <Button asChild size="large">
                  <Link href={DAPP_URL} target="_blank">
                    Start Using USDe
                  </Link>
                </Button>
                <Button variant="text" asChild size="large">
                  <Link href="/ecosystem">
                    <span>Explore the Ecosystem</span>
                    <Image
                      src="/shared/chevron-right.svg"
                      alt="chevron-right"
                      width={24}
                      height={24}
                      className="h-5 w-5"
                    />
                  </Link>
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
